import { create } from 'zustand';
import { TeamMember } from '../data/mockTeam';

interface TeamState {
  teamMembers: TeamMember[];
  setTeamMembers: (members: TeamMember[]) => void;
}

export const useTeamStore = create<TeamState>((set) => ({
  teamMembers: [],
  setTeamMembers: (members) => set({ teamMembers: members }),
}));
